export const environment = {
  production: true,
  version: require('../../package.json').version,
  backendUrl: `https://api.${location.hostname.split('.').slice(1).join('.')}`,
  title: 'OSTŘÍŽ'
};
